import { Paper, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { PropsWithChildren } from "react";

export type ContentSectionProps = {
    sx?: SxProps<Theme>;
    variant?: "outlined" | "elevation";
    elevation?: number;
};

export function ContentSection({
    sx,
    variant,
    elevation,
    children
}: PropsWithChildren<ContentSectionProps>) {
    return (
        <Paper id='contentsection'
            sx={{
                display: "flex",
                flexDirection: "column",
                flex: "1 1 auto",
                overflow: "hidden",
                position: "relative",
                ...sx
            }}
            variant={variant ?? "outlined"}
            elevation={elevation ?? 0}
        >
            {children}
        </Paper>
    );
}
